import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import allActions from '../redux/actions/user'
import { useSnackbar } from 'notistack'
import { useHistory } from 'react-router-dom'


export default function RattachementVerification(props) {
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()
  const history = useHistory()
  const state = useSelector(state => state)
  const { token: tokenMail } = props.match.params
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''

  useEffect(() => {

    async function fetchData() {
      const result = await allActions.fetchGetAPI(`api/users/valider-changement-mail/${tokenMail}`, dispatch, token)

      //Si la requête n'a pas fonctionnné une erreur est affiché
      if (result.err) {
        enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
        return
      }
  
      //Si le serveur retourne une erreur elle est affiché
      if (result?.json.err) {
        enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
        return
      }
  
      enqueueSnackbar(result.json.message, { variant: `success` })
      history.push('/')
    }

    fetchData()
    
  }, [])

  return null
}
